<template>
<div id="sheet-page-v2">
    <v-container fluid>
        <im-selection-bar :period_start.sync="period.start" :period_stop.sync="period.stop" :hotel_id="hotel.id" @net_price="selectNetPrice($event)" @updateRooms="selectRooms($event)" @updateRatePlans="selectRatePlans($event)" @nextPeriod="nextPeriod()"
            @prevPeriod="prevPeriod()" @refresh="refresh" />

        <template v-for="room in sheet.room_types">
            <template v-if="selected_rooms.includes(room.id)">
                <im-sheet-card :days="days" :room="room" :sheet="sheet" :selected_rooms="selected_rooms" :selected_rate_plans="selected_rate_plans" :net_price="net_price" :context="hotel.context" :weekend="hotel.weekend" :admin="admin" :master_leo="master_leo"
                    :params="sheet_params" ref="sheet-card" @select="select" @scroll="scroll" :backup_sheet="backup_sheet" @openDialogPricing="dialog_pricing=true" @openDialogInventory="openDialogInventory(room.id)" />
            </template>
        </template>
    </v-container>

    <!--  dialog inventory -->
    <im-inventory-modal :room_id="room_id" :room_types="room_types" :hotel_id="hotel.id" :dialog="dialog_inventory" :date_period="period" @close="dialog_inventory= false;room_id=null" @refresh="refresh()" />
    <!-- ./ dialog inventory  -->

    <!--  dialog pricing -->
    <im-pricing-modal :admin="admin" :room_types="room_types" :hotel_id="hotel.id" :currency="hotel.currency" :net_price="net_price" :dialog="dialog_pricing" :date_period="period" @close="dialog_pricing= false;" @refresh="refresh()" />
    <!-- ./ dialog pricing -->
</div>
</template>
<script>
import {
    mapActions
} from 'vuex';
import storage from '../../storage';
import IMFooter from '../../components/utils/IMFooter.vue';

import InventoryModal from '../../components/items/Sheet/InventoryModal.vue';
import PricingModal from '../../components/items/Sheet/PricingModal.vue';
import SelectionBar from '../../components/items/Sheet/SelectionBar.vue';
import SheetCard from '../../components/items/Sheet/SheetCard.vue';

export default {
    props: ['hotel'],
    name: `sheet`,
    components: {
        'im-inventory-modal': InventoryModal,
        'im-pricing-modal': PricingModal,
        'im-selection-bar': SelectionBar,
        'im-sheet-card': SheetCard,
        "im-footer": IMFooter,
    },

    data() {
        return {
            // card scroll
            selected: null,
            // seletion toolbar
            selected_rooms: [],
            selected_rate_plans: [],
            net_price: false,
            // input restrictions
            admin: false,
            master_leo: false,
            context: null,
            //dialogs
            dialog_pricing: false,
            dialog_inventory: false,
            room_id: null,

            weekend: [],
            mobile_picker: null,

            room_types: [],
            rate_plans: [],
            days: [],
            sheet: {
                inventory: {},
                pricing: {},
                room_types: []
            },
            backup_sheet: {
                inventory: {},
                pricing: {},
                room_types: []
            },
            period: {
                start: null,
                stop: null
            },

            today: new Date()
                .toISOString()
                .substr(0, 10),
        }
    },

    computed: {
        sheet_params() {
            let value = {
                hotel_id: this.hotel.id,
                date_start: this.period.start,
                date_stop: this.period.stop,
            }
            return value
        }
    },

    created() {
        this.getUserLeo();
    },

    async mounted() {
        this.getAllItems();
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    watch: {
        'hotel.id': {
            handler() {
                this.getAllItems();
            }
        },

        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                } else {}
            },
            deep: true,
            immediate: true
        },
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        openDialogInventory(value) {
            this.room_id = value;
            this.dialog_inventory = true;
        },

        select: function (room) {
            this.selected = room;
        },

        scroll: function () {
            this.$refs['sheet-card'].forEach(item => {
                if(item.room.id === this.selected.id) {
                    return
                }
                item.$refs['sheet-wrapper'].scrollLeft = event.target.scrollLeft;
            });
        },

        selectRooms(value) {
            this.selected_rooms = value;
        },
        selectRatePlans(value) {
            this.selected_rate_plans = value;
        },
        selectNetPrice(value) {
            this.net_price = value;
        },

        getUserLeo() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/users/me';

            this.$axios.get(endpoint)
                .then(response => {
                    this.master_leo = (response.data.email === "stirbu.leonard@mementohub.com");
                })
                .catch(error => {})
                .finally(() => {});
        },

        getAllItems() {
            if(this.$vuetify.breakpoint.smAndDown) {
                this.period.start = this.today
                this.period.stop = this.today
            }

            if(!this.hotel.id) {
                return
            }
            this.getHotelInfo()
                .then(() => this.getSheet())
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {});
        },

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }

                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {

                });
        },

        refresh() {
            this.getSheet()
        },

        getSheet() {
            if(!this.hotel.id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';

            // setup query params
            let params = {
                params: {
                    date_start: this.period.start,
                    date_stop: this.period.stop,
                    hotel_id: this.hotel.id,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {

                    this.days = response.data.days;
                    this.period = response.data.period;

                    this.room_types = this.buildRoomTypes(response.data.room_types);
                    this.sheet.room_types = this.room_types;

                    this.sheet.inventory = this.buildInventory(response.data.sheet.inventory);
                    this.sheet.pricing = this.buildPricing(response.data.sheet.pricing);

                    this.loading = false;
                    this.backup_sheet = this.$clone(this.sheet);
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {

                });
        },

        getHotelInfo() {
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + this.hotel.id;

            return this.$axios.get(endpoint)
                .then(response => {
                    this.context = response.data.context;
                    this.weekend = response.data.static.defaults.weekend;

                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });

                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        nextPeriod() {
            this.period.start = this.period.walk.next.date_start;
            this.period.stop = this.period.walk.next.date_stop;
            this.refresh();
        },

        prevPeriod() {
            this.period.start = this.period.walk.prev.date_start;
            this.period.stop = this.period.walk.prev.date_stop;
            this.refresh();
        },

        _obsolete_populateMissingData() {
            //verify the inventory
            if(!this.sheet.inventory) {
                this.sheet.inventory = {};
            }

            this.room_types.forEach(function (room, index_room) {
                if(!this.sheet.inventory[room.id]) {
                    this.$set(this.sheet.inventory, [room.id], {});
                    this.days.forEach(function (day, index_day) {
                        this.$set(this.sheet.inventory[room.id], day, {
                            'close_out': false,
                            'count': 0,
                            'booked': 0,
                            'date': day,
                            'hotel_id': this.hotel.id,
                            'room_type_id': room.id
                        });
                    }.bind(this))
                } else {
                    this.days.forEach(function (day, index_day) {
                        if(!this.sheet.inventory[room.id][day]) {
                            this.$set(this.sheet.inventory[room.id], day, {
                                'close_out': false,
                                'count': 0,
                                'booked': 0,
                                'date': day,
                                'hotel_id': this.hotel.id,
                                'room_type_id': room.id
                            });
                        }
                    }.bind(this))
                }
            }.bind(this))
            //verify the pricing
            if(!this.sheet.pricing) {
                this.sheet.pricing = {};
                // this.$set(this.sheet, inventory, {});
            }
            this.room_types.forEach(function (room, index_room) {
                if(!this.sheet.pricing[room.id]) {
                    this.$set(this.sheet.pricing, [room.id], {});
                    room.rate_plans.forEach(function (rate_plan, index_rate_plan) {
                        this.$set(this.sheet.pricing[room.id], [rate_plan.id], {});
                        this.days.forEach(function (day, index_day) {
                            this.$set(this.sheet.pricing[room.id][rate_plan.id], day, {
                                'closed_arrival': false,
                                'closed_departure': false,
                                'date': day,
                                'hotel_id': this.hotel.id,
                                'min_stay': null,
                                'max_stay': null,
                                'price': 0,
                                'price_single': null,
                                'stop_sell': false,
                                'rate_plan_id': rate_plan.id,
                                'room_type_id': room.id
                            });
                        }.bind(this))
                    }.bind(this))
                } else {
                    room.rate_plans.forEach(function (rate_plan, index_rate_plan) {
                        if(!this.sheet.pricing[room.id][rate_plan.id]) {
                            this.$set(this.sheet.pricing[room.id], [rate_plan.id], {});
                            this.days.forEach(function (day, index_day) {
                                this.$set(this.sheet.pricing[room.id][rate_plan.id], day, {
                                    'closed_arrival': false,
                                    'closed_departure': false,
                                    'date': day,
                                    'hotel_id': this.hotel.id,
                                    'min_stay': null,
                                    'max_stay': null,
                                    'price': 0,
                                    'price_single': null,
                                    'stop_sell': false,
                                    'rate_plan_id': rate_plan.id,
                                    'room_type_id': room.id
                                });
                            }.bind(this))
                        } else {
                            this.days.forEach(function (day, index_day) {
                                if(!this.sheet.pricing[room.id][rate_plan.id][day]) {
                                    this.$set(this.sheet.pricing[room.id][rate_plan.id], day, {
                                        'closed_arrival': false,
                                        'closed_departure': false,
                                        'date': day,
                                        'hotel_id': this.hotel.id,
                                        'min_stay': null,
                                        'max_stay': null,
                                        'price': 0,
                                        'price_single': null,
                                        'stop_sell': false,
                                        'rate_plan_id': rate_plan.id,
                                        'room_type_id': room.id
                                    });
                                }
                            }.bind(this))
                        }
                    }.bind(this))
                }
            }.bind(this))
        },

        /**
         * We set the edit_restriction to false for each 
         * room_type and rate_plan
         */
        buildRoomTypes(room_types) {
            room_types.forEach(function (room) {
                room.edit_restriction = false;
                room.rate_plans.forEach(function (plan) {
                    plan.edit_restriction = false;
                });
            });

            return room_types;
        },

        buildInventory(request_inventory) {
            let inventory = this.buildDefaultInventory();
            
            for (let room_id in request_inventory) {
                for (let day in request_inventory[room_id]) {
                    inventory[room_id][day] = request_inventory[room_id][day];
                }
            }

            return inventory;
        },

        buildPricing(request_pricing) {
            let pricing = this.buildDefaultPricing();
            for (let room_id in request_pricing) {
                for (let plan_id in request_pricing[room_id]) {
                    for (let day in request_pricing[room_id][plan_id]) {
                        if (pricing.hasOwnProperty(room_id) && pricing[room_id].hasOwnProperty(plan_id)) {
                            pricing[room_id][plan_id][day] = request_pricing[room_id][plan_id][day];
                        }
                    }
                }
            }

            return pricing;
        },

        buildDefaultInventory() {
            let inventory = {};
            this.room_types.forEach(function (room) {
                let room_inventory = {};
                this.days.forEach(function (day) {
                    room_inventory[day] = this.defaultInventory(day, room.id);
                }.bind(this));
                inventory[room.id] = room_inventory;
            }.bind(this));

            return inventory;
        },

        buildDefaultPricing() {
            let pricing = {};

            this.room_types.forEach(function (room) {
                let plans = {};
                room.rate_plans.forEach(function (plan) {
                    let plan_pricing = {};
                    this.days.forEach(function (day) {
                        plan_pricing[day] = this.defaultPricing(day, room.id, plan.id);
                    }.bind(this));
                    plans[plan.id] = plan_pricing;
                }.bind(this));
                pricing[room.id] = plans;
            }.bind(this));

            return pricing;
        },

        defaultInventory(day, room_id) {
            return {
                'hotel_id': this.hotel.id,
                'room_type_id': room_id,
                'date': day,
                'booked': 0,
                'count': 0,
                'close_out': false,
            }
        },

        defaultPricing(day, room_id, plan_id) {
            return {
                'hotel_id': this.hotel.id,
                'room_type_id': room_id,
                'rate_plan_id': plan_id,
                'date': day,
                'closed_arrival': false,
                'closed_departure': false,
                'min_stay': null,
                'max_stay': null,
                'price': 0,
                'price_single': null,
                'stop_sell': false,
            }
        },

        mobileDate() {
            this.period.start = this.mobile_picker;
            this.period.stop = this.mobile_picker;
            this.getSheet();
        },

    }
}
</script>
<style lang="stylus">
.friendly-reminder
    height: -webkit-fill-available
    text-align: center
    justify-content: center
    margin-top: -120px
    display: flex
    align-items: center
    font-size: 32px
    color: lightslategrey
    font-weight: 600

</style>
